import React, { useState } from 'react';
import { Star } from 'lucide-react';

export function StarRating({ value = 0, onRate, size = 'md', readOnly = false, testId = 'star-rating' }) {
  const [hover, setHover] = useState(0);
  const px = size === 'sm' ? 'w-3.5 h-3.5' : size === 'lg' ? 'w-7 h-7' : 'w-5 h-5';
  const shown = hover || value;

  return (
    <div className="inline-flex items-center gap-0.5" data-testid={testId} role={readOnly ? 'img' : 'radiogroup'} aria-label={`Calificacion ${value} de 5`}>
      {[1, 2, 3, 4, 5].map(n => {
        const filled = n <= Math.round(shown);
        const half = !filled && n - 0.5 <= shown;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onRate?.(n)}
            className={`relative ${readOnly ? 'cursor-default' : 'cursor-pointer transition-transform hover:scale-110'}`}
            aria-label={`${n} estrella${n > 1 ? 's' : ''}`}
            data-testid={`${testId}-star-${n}`}
          >
            <Star className={`${px} ${filled || half ? 'text-amber-400' : 'text-gray-300'}`} strokeWidth={1.5} fill={filled ? 'currentColor' : 'none'} />
            {half && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: '50%' }}>
                <Star className={`${px} text-amber-400`} strokeWidth={1.5} fill="currentColor" />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export function RatingSummary({ avg = 0, count = 0, size = 'sm', testId = 'rating-summary' }) {
  if (!count) return null;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-sans text-gray-500" data-testid={testId}>
      <StarRating value={avg} size={size} readOnly testId={`${testId}-stars`} />
      <span className="font-medium text-slate-dark">{avg.toFixed(1)}</span>
      <span className="text-gray-400">({count})</span>
    </span>
  );
}
